<template>
	<div>
		<el-dialog :title="title" :visible.sync="visible" width="500px" :before-close="() => handleClose()">
			<el-form
				:model="shopProduct"
				ref="productImportForm"
				:rules="rules"
				label-width="110px"
				size="mini"
				:inline="true"
			>
				<el-form-item label="商品名称" prop="proNos">
					<el-input
						:readonly="true"
						placeholder="请选择供应链商品"
						size="small"
						style="width: 260px"
						:value="compProNos"
					>
						<el-button slot="append" @click="dialogVisible = true" icon="el-icon-search"></el-button>
					</el-input>
					<SelectDialog :visible="dialogVisible" title="请选择商品" @close="handleSelectDialog"></SelectDialog>
				</el-form-item>
				<el-form-item label="所属店铺" prop="shopId">
					<el-input
						v-if="isShopManageRole"
						:disabled="true"
						placeholder="请选择所属店铺"
						size="small"
						style="width: 260px"
						:value="currentShop.shopName"
					>
						<el-button slot="append" icon="el-icon-search"></el-button>
					</el-input>
					<GridSelectShop
						v-else
						style="width: 260px"
						title="选择店铺"
						labelName="shopName"
						labelValue="id"
						:value="shopProduct.shopId"
						:limit="1"
						size="small"
						@getValue="getValueShopId"
						:columns="SHOP_code"
						:searchs="SHOP_search"
						dataListUrl="/mall/shop/findList"
						entityBeanName="mallShop"
						queryEntityUrl="/mall/shop/get"
					></GridSelectShop>
				</el-form-item>
				<el-form-item label="价格填充策略" prop="priceStrategy">
					<el-select
						style="width: 260px"
						v-model="shopProduct.priceStrategy"
						placeholder="请选择"
						clearable
						size="small"
					>
						<el-option
							v-for="item in priceStrategyList"
							:key="item.value"
							:label="item.label"
							:value="item.value"
						></el-option>
					</el-select>
				</el-form-item>
				<el-form-item v-if="shopProduct.priceStrategy === 'PERCENT_MARKUP'" label="利润率" prop="markupRate">
					<el-input
						style="width: 260px"
						size="small"
						v-model="shopProduct.markupRate"
						placeholder="请输入商品的利润率"
					></el-input>
				</el-form-item>
			</el-form>

			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="handleConfirm()">确 定</el-button>
				<el-button @click="handleClose()">取 消</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import { SHOP, SHOP_SEARCH } from "@/utils/constant.js";
	import GridSelectShop from "@/components/gridselect/gidselect.vue";
	import SelectDialog from "./SelectDialog.vue";
	import { get, postJson } from "@/utils/request";
	export default {
		data() {
			return {
				SHOP_code: SHOP,
				SHOP_search: SHOP_SEARCH,
				priceStrategyList: [],
				shopProduct: {
					proNos: [],
					shopId: "",
					priceStrategy: "ADVISE_PRICE",
					markupRate: "",
					// defaultStatus: 2,
					isFreightFree: 1,
					skipExisting: true,
				},
				rules: {
					proNos: [{ required: true, message: "商品名称不能为空", trigger: "blur" }],
					shopId: [{ required: true, message: "所属店铺不能为空", trigger: "blur" }],
					priceStrategy: [{ required: true, message: "价格填充策略不能为空", trigger: "blur" }],
					markupRate: [{ required: true, message: "利润率不能为空", trigger: "blur" }],
				},
				dialogVisible: false,
				currentShop: {},
			};
		},
		computed: {
			compProNos() {
				return this.shopProduct.proNos.map((item) => item.title).join("，");
			},
			isShopManageRole() {
				let { mppRoleList } = this.$store.state.userInfo;
				return mppRoleList.some((item) => item.roleName === "店铺管理");
			},
		},
		props: {
			visible: {
				type: Boolean,
				default: false,
			},
			title: {
				type: String,
				default: "",
			},
		},
		created() {
			this.priceStrategyList = [
				{ value: "ADVISE_PRICE", label: "供应链建议零售价" },
				{ value: "SUPPLY_PRICE", label: "供货价" },
				{ value: "PERCENT_MARKUP", label: "供货价 × (1 + 利润率)" },
				// { value: "FIXED_MARKUP", label: "供货价 + markupAmount 固定加价" },
			];
			if (this.isShopManageRole) {
				get("/mall/shop/findOneShop?pageNum=1&pageSize=10").then((res) => {
					if (res.success && res.code == 200) {
						let shop = res.page.list[0];
						this.shopProduct.shopId = shop.id;
						this.currentShop = shop;
					} else {
						this.$message({
							message: res.msg,
							type: "error",
							duration: 2000,
						});
					}
				});
			}
		},
		methods: {
			getValueShopId(value) {
				this.shopProduct.shopId = value;
			},
			handleSelectDialog(data) {
				console.log("handleSelectDialog", data);
				this.dialogVisible = false;
				if (data) {
					this.shopProduct.proNos = data;
				}
			},
			handleConfirm() {
				this.$refs["productImportForm"].validate((valid) => {
					if (valid) {
						let params = {
							...this.shopProduct,
							proNos: this.shopProduct.proNos.map((item) => item.proNo),
						};
						console.log(params);
						postJson("/shop/supply-chain/stock/products/import", params).then((res) => {
							this.$message({
								message: res.msg,
								type: "success",
								duration: 2000,
							});
							this.handleClose({ confirm: true });
						});
					} else {
						console.log("error submit!!");
						return false;
					}
				});
			},
			handleClose(data) {
				this.$emit("close", data);
			},
		},
		components: {
			GridSelectShop,
			SelectDialog,
		},
	};
</script>

<style lang="scss" scoped>
	::v-deep > .el-dialog {
		margin-top: 5vh !important;
	}
	.main-img {
		display: flex;
		justify-content: center;
	}
</style>
